<template>
    <otif-modal
        ref="eventModel"
        title="Event Details"
        :value="value"
        @input="$emit('input', $eventId)"
        @shown="eventData"
        v-if="eventId"
    >
        <b-row class="OTEventDisplay">
            <b-col class="OTEventDisplayLeft" cols="5">
                <h5 class="OTEventDisplayTitle">General Information</h5>
                <b-row>
                    <b-col cols="6" class="OTEventDisplayLabel">Level :</b-col>
                    <b-col
                        cols="6"
                        v-bind:class="'OTEventDisplayData OTEventsRowTitle OTEventsRowTitle-' + this.selectedEventDetails.severity" 
                        
                    >{{this.selectedEventDetails.severity}}</b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" class="OTEventDisplayLabel">Date :</b-col>
                    <b-col
                        cols="6"
                        class="OTEventDisplayData"
                    >{{getDate()}}</b-col>
                </b-row>
                <h5 class="OTEventDisplayTitle mt-4">Others</h5>
                <b-row>
                    <b-col cols="6" class="OTEventDisplayLabel">Host :</b-col>
                    <b-col cols="6" class="OTEventDisplayData">---</b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" class="OTEventDisplayLabel">Job Id :</b-col>
                    <b-col cols="6" class="OTEventDisplayData">{{this.selectedEventDetails.jobId}}</b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" class="OTEventDisplayLabel">Project Name:</b-col>
                    <b-col
                        cols="6"
                        class="OTEventDisplayData"
                    >{{this.selectedEventDetails.groupName}}</b-col>
                </b-row>
            </b-col>
            <b-col class="OTEventDisplayRight" cols="7">
                <h5 class="OTEventDisplayTitle">Event Description</h5>
                
                
                <div class="row">
                    <div class="OTEventDisplayData col-12 text-left"> {{this.selectedEventDetails.description}}</div>
            </div>
               <!-- <b-row>
                    <b-col
                        cols="6"
                        class="OTEventDisplayData text-left"
                    >{{this.selectedEventDetails.description}}</b-col>
                </b-row>-->
            </b-col>
        </b-row>
        <template slot="footer">
            <b-button @click="cancel" variant="  OTSecondary">Close</b-button>
        </template>
    </otif-modal>
</template>
</otif-modal>

</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators";

export default {
    props: ["value"],
    data() {
        return {
            eventId: null,
            selectedEventDetails: []
        };
    },

    methods: {
        cancel() {
            this.$emit("input", false);
        },

        async eventData() {
            const res = await axios.get(
                "mtm-gateway-api/v1/services/dashboard/events/" + this.eventId
            );
            this.resource = res.data;
            this.selectedEventDetails = this.resource;
        },
		
		getDate(){
            var date = new Date(this.selectedEventDetails.timeStamp);
            return date.toLocaleDateString(date,{year:'numeric', month:'long', day:'numeric'}) + ' @ ' + date.toLocaleTimeString(date,{hour:'numeric',minute:'numeric'});
        }
    }
};
</script>
